import isEqual from "lodash/isEqual";
import fromPairs from "lodash/fromPairs";
import toPairs from "lodash/toPairs";
import differenceWith from "lodash/differenceWith";

export const debugUser = {
  email: import.meta.env.VITE_DEBUG_EMAIL || "",
  password: import.meta.env.VITE_DEBUG_PASSWORD || "",
  personnummer: import.meta.env.VITE_DEBUG_PERSONNUMMER || ""
};

export function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function objectDifferences(a: object, b: object) {
  const objectDiff = (a: object, b: object) =>
    fromPairs(differenceWith(toPairs(a), toPairs(b), isEqual));
  const result: (string | unknown)[] = [];
  Object.keys(objectDiff(a, b)).forEach(key => {
    const aValue = (a as Record<string, unknown>)[key];
    const bValue = (b as Record<string, unknown>)[key];
    if (
      aValue &&
      typeof aValue === "object" &&
      bValue &&
      typeof bValue === "object"
    ) {
      Object.entries(objectDifferences(aValue, bValue)).forEach(
        ([key2, value]) => {
          result.push([key + "." + key2, value]);
        }
      );
      // result.push([key, objectDifferences(aValue, bValue)]);
    } else {
      result.push([key, [aValue, bValue]]);
    }
  });
  return Object.fromEntries(result as Iterable<[string]>);
}
